angular.module('lf.common', []);

angular.module('lf.desktop', [
  'lf.common',
  'ngSanitize'
])

.value('preloadData', lf.data.xhr)

.constant('i18n', lf.data.i18n);
